import * as React from "react";
import { NewModal } from "../uiMerge/newModal";
import NewButton from "../uiMerge/newButton";
import TermsAndConditionsModal from "./termsAndConditionsModal";

type OfferConfirmationModalProps = {
  visible: boolean;
  onCancel: () => void;
  isSubmitting?: boolean;
  onClick?: () => void;
  offerName: string;
  offerTOR: string;
};
const OfferConfirmationModal: React.FC<OfferConfirmationModalProps> = ({
  visible,
  onCancel,
  onClick,
  isSubmitting,
  offerName,
  offerTOR
}) => {
  const [offerTermModalVisible, setOfferTermModalVisible] =
    React.useState(false);

  const handleOfferTermCancel = () => setOfferTermModalVisible(false);

  return (
    <NewModal
      isOpen={visible}
      roundedClass="rounded-[10px]"
      colorClass="bg-black"
      widthClass="w-[335px]"
      position="center"
      onClose={onCancel}
    >
      <div className="flex h-[290px] justify-center">
        <div className="flex flex-col items-center justify-center mt-6 py-[2px] gap-3 w-[275px]">
          <p className="font-extrabold text-center text-white text-[20px]">
            Are you sure you want to redeem this offer?
          </p>
          <p
            onClick={() => setOfferTermModalVisible(true)}
            className="text-[#C553FC] text-[12px] cursor-pointer text-center"
          >
            Terms & Conditions Apply
          </p>

          <div className="flex gap-4 items-center  mt-6 w-full">
            <NewButton fullWidth onClick={onCancel} variant="outline">
              Cancel
            </NewButton>

            {/* <NewButton
              fullWidth
              onClick={onClick}
              //   type="submit"
              type="button"
              disabled={isSubmitting}
            >
              Redeem
            </NewButton> */}

            <NewButton fullWidth onClick={onClick} disabled={isSubmitting}>
              Redeem
            </NewButton>
          </div>
        </div>
      </div>
      <TermsAndConditionsModal
        visible={offerTermModalVisible}
        onCancel={handleOfferTermCancel}
        offerName={offerName}
        offerTOR={offerTOR}
      />
    </NewModal>
  );
};

export default OfferConfirmationModal;
